<template>
    <div id="front">
        <FrontPage/>
    </div>
</template>

<script>
    import FrontPage from '../components/FrontPage';
    import { mapGetters } from 'vuex';

    export default {
        name: 'Front',
        components: {
            FrontPage,
        },
        computed:{
            ...mapGetters([])
        },
        created() {
            //console.log("rerender");
        },
    }
</script>

<style lang="scss" scoped>
    #home{
        opacity: 1;
    }
</style>